<template>
  <mobile-menu />
</template>

<script>
import MobileMenu from '@/components/navigation/MobileMenu.vue'

export default {
  name: 'MenuView',
  components: { MobileMenu }
}
</script>
